// extracted by mini-css-extract-plugin
module.exports = {"loading-backdrop":"Loading_loading-backdrop__2BfPu","loading":"Loading_loading__pUBux"};